import { combineReducers, AnyAction } from 'redux'
import storage from 'redux-persist/lib/storage'

// Type
export type RootState = ReturnType<typeof appReducer>

// Site reducers
import profile from '../containers/SignInPage/reducer'
import profileTeachers from '../containers/ProfileTeachersPage/reducer'
import profileParents from '../containers/ProfileParentsPage/reduсer'
import profileContests from '../containers/ProfileContestsPage/reducer'
import profileContestWork from '../containers/ProfileContestsWorkPage/reducer'
import profileContestWorksList from '../containers/ProfileContestsWorksListPage/reducer'
import profileAchievements from '../containers/ProfileAchievementsPage/reducer'
import profileExpertCabinet from '../containers/ProfileExpertCabinetPage/reducer'
import notion from '../containers/NotionPage/reducer'
import coursesList from '../containers/CoursesListPage/reducer'
import coursePage from '../containers/CoursePage/reducer'
import modulePage from '../containers/ModulePage/reducer'
import moduleScreenPage from '../containers/ModuleScreenPage/reducer'
import moduleLessonPage from '../containers/LessonPage/reducer'

// Admin reducers
import adminCoursesList from '../containers/AdminCoursesListPage/reducer'
import adminCourseCreate from '../containers/AdminCourseCreatePage/reducer'
import adminCourseEdit from '../containers/AdminCourseEditPage/reducer'
import adminLessonsList from '../containers/AdminLessonsListPage/reducer'
import adminLessonCreate from '../containers/AdminLessonCreatePage/reducer'
import adminLessonEdit from '../containers/AdminLessonEditPage/reducer'
import adminLessonBlocks from '../containers/AdminLessonBlocksPage/reducer'
import adminModuleCreate from '../containers/AdminCourseCreatePage/reducer'
import adminModuleEdit from '../containers/AdminModuleEditPage/reducer'
import adminModulesList from '../containers/AdminModulesListPage/reducer'
import adminModuleScreenBlocks from '../containers/AdminModuleScreenBlocks/reducer'
import adminBlockEdit from '../containers/AdminBlockEditPage/reducer'
import adminMapEdit from '../containers/AdminMapEditPage/reducer'
import adminAchievements from '../containers/AdminAchievementsPage/reducer'
import adminAchievementEdit from '../containers/AdminAchievementEditPage/reducer'
import adminUsers from '../containers/AdminUsersPage/reducer'
import adminUserView from '../containers/AdminUserViewPage/reducer'

const appReducer = combineReducers({
  profile,
  profileTeachers,
  profileParents,
  profileContests,
  profileContestWork,
  profileContestWorksList,
  profileAchievements,
  profileExpertCabinet,
  notion,
  coursesList,
  coursePage,
  modulePage,
  moduleScreenPage,
  moduleLessonPage,
  adminCoursesList,
  adminCourseCreate,
  adminCourseEdit,
  adminLessonsList,
  adminLessonCreate,
  adminLessonEdit,
  adminLessonBlocks,
  adminModuleCreate,
  adminModuleEdit,
  adminModulesList,
  adminModuleScreenBlocks,
  adminBlockEdit,
  adminMapEdit,
  adminAchievements,
  adminAchievementEdit,
  adminUsers,
  adminUserView,
})

const rootReducer = (state: RootState, action: AnyAction) => {
  if (action.type === '@@profile/SIGN_OUT_SUCCESS') {
    storage.removeItem('persist:root')
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export default rootReducer
